<template>
  <v-container fluid>
    <h3 class="mb-5">RC Broker</h3>

    <div
      class="dataContainer"
      @keydown.enter.prevent="saveData()"
      @keydown.esc.prevent="cancelData()"
    >
      <el-overlay-loading :loading="loading" />

      <template v-if="showError">
        <v-row>
          <v-col cols="12">
            <v-alert dense outlined type="error">
              Klaida
            </v-alert>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-card-text>
                {{ errorMsg }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <v-row>
        <v-col cols="12" md="6">
          <el-text-field label="Tipas" v-model="tipas" />
        </v-col>
        <v-col cols="12" md="6">
          <el-autocomplete
            :items="formatasList"
            itemvalue="value"
            itemtext="text"
            label="Formatas"
            v-model="formatas"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-textarea label="Parametrai" v-model="parametrai" />
        </v-col>
      </v-row>
    </div>

    <v-footer class="form-footer">
      <el-button primary @click.native="saveData()" :loading="loading"
        >Saugoti</el-button
      >
      <el-button @click.native="cancelData()" :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  name: 'AdminBroker',
  data() {
    return {
      loading: false,
      tipas: null,
      parametrai: null,
      formatas: 'pdf',
      errorMsg: null,
      showError: false,
    }
  },
  computed: {
    formatasList() {
      return [
        {
          text: 'XML',
          value: 'xml',
        },
        {
          text: 'PDF',
          value: 'pdf',
        },
      ]
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  created() {
    //
  },
  methods: {
    saveData(toRoute) {
      this.loading = true
      this.showError = false

      let data = {
        tipas: this.tipas,
        parametrai: this.parametrai ? this.parametrai.split('\n') : [],
        format: this.formatas,
      }

      this.$axios
        .post(`admin/brokeris`, data, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          this.openFile(res.data)
        })
        .catch(err => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.errorMsg = errData.message
          this.showError = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.showError = false
      this.tipas = null
      this.parametrai = null
      this.formatas = 'pdf'
    },
    openFile(fileData) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', `broker.${this.formatas}`)
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
